import { useMutation } from '@tanstack/react-query';

import type { RegenerateTokenResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useRegenerateTokenMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<RegenerateTokenResponse>({
        method: 'POST',
        url,
      }),
  });
